import { Box, Button, IconButton, Popover, Typography } from '@mui/material';
import React from 'react';
import Container from '../../components/LandingPage/Container';
import { Menu } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FloatingMenu: React.FC<{
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  menuItens: { label: string; href: string }[];
  storeButton: { label: string; href: string };
  handleMenuClick: (href: string) => void;
}> = ({ open, anchorEl, onClose, menuItens, storeButton, handleMenuClick }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      disableScrollLock
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          mt: 1,
          px: 3,
          py: 2,
          borderRadius: '12px',
          boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <Box display="flex" flexDirection="column" gap="12px" width="200px">
        {menuItens.map(item => (
          <Button
            key={item.label}
            variant="text"
            color="inherit"
            sx={{
              justifyContent: 'flex-start',
              fontWeight: 400,
              '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
            }}
            onClick={() => handleMenuClick(item.href)}
          >
            <Typography>{item.label}</Typography>
          </Button>
        ))}
        <Button
          variant="contained"
          color="primary"
          sx={{
            fontWeight: '500',
            color: 'white',
            '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
          }}
          onClick={() => handleMenuClick(storeButton.href)}
        >
          <Typography>{storeButton.label}</Typography>
        </Button>
      </Box>
    </Popover>
  );
};

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuClick = (href: string) => {
    navigate(href);
    setMenuAnchorEl(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const isMenuOpen = Boolean(menuAnchorEl);

  const menuItens = [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'Portifólio',
      href: '/portfolio',
    },
    {
      label: 'Serviços',
      href: '/services',
    },
  ];

  const storeButton = {
    label: 'Loja do Revendedor',
    href: '/store',
  };

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" width="100%" padding="22px 0">
        <Box display="flex" gap={{ xs: '16px', md: '29px' }}>
          <Box width="auto" height={{ xs: '32px', lg: '39px' }}>
            <img
              width="auto"
              height="100%"
              src="/images/acer-for-business-logo2.png"
              alt="Acer for Business"
            />
          </Box>
          <Box width="1px" borderLeft="1px solid rgba(0, 0, 0, 0.12)" height="100%"></Box>
          <Box width="auto" height={{ xs: '28px', lg: '35px' }}>
            <img width="auto" height="100%" src="/images/cisp1-logo.png" alt="CISP1" />
          </Box>
        </Box>
        <Box display={{ xs: 'none', md: 'flex' }} gap="90px">
          {/* <Box display="flex" gap="30px">
            {menuItens.map((item) => (
              <Box key={item.label}>
                <Button
                  variant="text"
                  color="inherit"
                  sx={{
                    fontWeight: '400',
                    '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                  }}
                  onClick={() => handleMenuClick(item.href)}
                >
                  <Typography>{item.label}</Typography>
                </Button>
              </Box>
            ))}
          </Box>
          <Box>
            <Button
              variant="contained"
              color="primary"
              sx={{
                fontWeight: '500',
                color: 'white',
                '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
              }}
              onClick={() => handleMenuClick(storeButton.href)}
            >
              <Typography>{storeButton.label}</Typography>
            </Button>
          </Box> */}
        </Box>
        {/* <Box display={{ xs: 'flex', md: 'none' }}>
          <IconButton onClick={handleMenuOpen}
            sx={{
              '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
            }}>
            <Menu />
          </IconButton>
          <FloatingMenu open={isMenuOpen} anchorEl={menuAnchorEl} onClose={handleMenuClose} menuItens={menuItens} storeButton={storeButton} handleMenuClick={handleMenuClick} />
        </Box> */}
      </Box>
    </Container>
  );
};

export default Header;
